import axios from "axios";

export const uploadImagesApiRequest = async (images, quoteId) => {
    const formData = new FormData();
    Array.from(images).forEach((image) => {
        formData.append("images", image);
    });
    const { data } = await axios.post("/api/quotes/upload?quoteId=" + quoteId, formData);
    return data;
};

export const uploadImagesCloudinaryApiRequest = async (images, quoteId, index) => {
    const storageZoneName = 'ctaus/quote'; // Replace with your storage zone name
    const storageApiKey = '43646dd6-33b3-4d26-891c7d9ce239-5097-48e2'; // Replace with your storage API key
    for (let i = 0; i < images.length; i++) {
        const fileName = images[i].name;
        const file = images[i]
        const url = `https://ctladmin.b-cdn.net/quote/${fileName}`

        // Construct the API endpoint
        const endpoint = `https://storage.bunnycdn.com/${storageZoneName}/${fileName}`;
        try {
            await axios.put(endpoint, file, {
                headers: {
                    'AccessKey': storageApiKey,
                    'Content-Type': file.type,
                },
            })
                .then(response => {
                    return response
                })
                .then(data => {
                    axios.post("/api/quotes/upload?bunny=true&quoteId=" + quoteId, { url: url });
                })
        } catch (error) {
            console.error('Upload failed:', error);
        }
    }
}





/* export const uploadImagesCloudinaryApiRequest = (images, quoteId) => {
    const url = "https://api.cloudinary.com/v1_1/dxvwresim/image/upload";
    const formData = new FormData();
    for (let i = 0; i < images.length; i++) {
        let file = images[i];
        formData.append("file", file);
        formData.append("upload_preset", "clientQuoteImage");
        fetch(url, {
            method: "POST",
            body: formData,
        })
        .then(response => {
            return response.json();
        })
        .then(data => {
            axios.post("/api/quotes/upload?cloudinary=true&quoteId=" + quoteId, data);
            console.log(data);

        })
    }
} */

/* export const uploadImagesCloudinaryApiRequest = (images) => {
    const url = "https://api.cloudinary.com/v1_1/dxvwresim/image/upload";
    const promises = [];
  
    for (let i = 0; i < images.length; i++) {
      const formData = new FormData();
      formData.append("file", images[i]);
      formData.append("upload_preset", "clientQuoteImage");
      
      promises.push(
        fetch(url, {
          method: "POST",
          body: formData,
        })
        .then(response => response.json())
        .then(data => data.secure_url)
      );
    }
  
    return Promise.all(promises);
  };
   */



export const uploadPdfApiRequest = async (pdfs, productId) => {
    const formData = new FormData();
    Array.from(pdfs).forEach((pdf) => {
        formData.append("pdfs", pdf);
    });
    const { data } = await axios.post("/api/products/admin/uploadpdf?productId=" + productId, formData);
    return data;
};

export const uploadPdfCloudinaryApiRequest = (pdfs, productId) => {
    const url = "https://api.cloudinary.com/v1_1/dxvwresim/image/upload";
    const formData = new FormData();
    for (let i = 0; i < pdfs.length; i++) {
        let file = pdfs[i];
        formData.append("file", file);
        formData.append("upload_preset", "CTLpdf");
        fetch(url, {
            method: "POST",
            body: formData,
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                axios.post("/api/products/admin/uploadpdf?cloudinary=true&productId=" + productId, data);
            })
    }
}

export function titleCase(str) {
    var splitStr = str.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(' ');
}
